import React, { Component } from 'react'
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Chip,
  Collapse,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'
import SearchIcon from '@mui/icons-material/Search'
import ClearIcon from '@mui/icons-material/Clear'
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded'
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded'
import PointOfSaleRoundedIcon from '@mui/icons-material/PointOfSaleRounded'
import AutorenewRoundedIcon from '@mui/icons-material/AutorenewRounded'

import ItemCajero from './ItemCajero'
import ItemCajeroIncidencia from './ItemCajeroIncidencia'

const RestTunel = require('../../libs/rest_tunnel')

const INTERVALO_UPDATE_MS = 10000

function StatCard({ icon, label, value, color }) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: '14px',
        border: '1px solid rgba(0,0,0,0.06)',
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        backgroundColor: '#fff',
        minHeight: 72,
      }}
    >
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: `${color}1A`,
          color,
        }}
      >
        {icon}
      </Box>
      <Box>
        <Typography variant="caption" sx={{ color: '#666', textTransform: 'uppercase', letterSpacing: '0.06em', fontWeight: 600 }}>
          {label}
        </Typography>
        <Typography variant="h5" sx={{ fontWeight: 800, lineHeight: 1.1, color: '#222' }}>
          {value}
        </Typography>
      </Box>
    </Paper>
  )
}

class CajeroEstadosPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      grupos: [],
      categoriasEstados: [],
      cajeros: [],
      cajerosConIncidencia: [],
      filtroBusqueda: '',
      filtroGrupo: 0,
      ultimaActualizacion: null,
      cargando: false,
      mostrarAlerta: false,
      mensajeAlerta: '',
      severidadAlerta: 'info',
    }

    this.updateCajerosEstados = this.updateCajerosEstados.bind(this)
    this.btnFiltrarCajeros = this.btnFiltrarCajeros.bind(this)
    this.handleGrupoChange = this.handleGrupoChange.bind(this)
    this.handleBusquedaChange = this.handleBusquedaChange.bind(this)
  }

  componentDidMount() {
    this.timerRefrescarCajerosEstados = setInterval(this.updateCajerosEstados, INTERVALO_UPDATE_MS)
    this.queryGrupos()
    this.queryCategoriasEstados()
    this.updateCajerosEstados()
  }

  componentWillUnmount() {
    clearInterval(this.timerRefrescarCajerosEstados)
  }

  btnFiltrarCajeros() {
    this.updateCajerosEstados()
  }

  handleGrupoChange(e) {
    this.setState({ filtroGrupo: e.target.value }, () => this.updateCajerosEstados())
  }

  handleBusquedaChange(e) {
    this.setState({ filtroBusqueda: e.target.value })
  }

  queryGrupos() {
    var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {},
      url: process.env.REACT_APP_URL_BACKEND + '/usuarios/grupos/list',
    }

    RestTunel.makePetition(restArgs, (err, data) => {
      if (err) {
        this.setState({
          grupos: [],
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando grupos',
          severidadAlerta: 'error',
        })
      } else {
        this.setState({ grupos: data })
      }
    })
  }

  queryCategoriasEstados() {
    var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: {},
      url: process.env.REACT_APP_URL_BACKEND + '/cajeroestados/listaestados',
    }

    RestTunel.makePetition(restArgs, (err, data) => {
      if (err) {
        this.setState({
          categoriasEstados: [],
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando lista estados',
          severidadAlerta: 'error',
        })
      } else {
        this.setState({ categoriasEstados: data.categoriasEstados })
      }
    })
  }

  updateCajerosEstados() {
    const filtroIdGrupo = this.state.filtroGrupo !== 0 ? this.state.filtroGrupo : ''

    this.setState({ cargando: true })

    var restArgs = {
      method: 'POST',
      headers: 'JSON',
      body: { filtro_id_grupo: filtroIdGrupo },
      url: process.env.REACT_APP_URL_BACKEND + '/cajeroestados/cajerosestados',
    }

    RestTunel.makePetition(restArgs, (err, data) => {
      if (err) {
        this.setState({
          cajeros: [],
          cargando: false,
          mostrarAlerta: true,
          mensajeAlerta: 'Error consultando cajeros',
          severidadAlerta: 'error',
        })
      } else {
        this.setState(
          {
            cajeros: data.cajeros,
            cargando: false,
            ultimaActualizacion: new Date(),
          },
          () => this.buscarCajerosConIncidencias()
        )
      }
    })
  }

  buscarCajerosConIncidencias() {
    var cajerosConIncidencias = []
    var cajeros = this.state.cajeros

    cajeros.forEach((cajero) => {
      cajero.estados.every((estado) => {
        if (estado.codigo === 1) {
          cajerosConIncidencias.push(cajero)
          return false
        }
        return true
      })
    })

    this.setState({ cajerosConIncidencia: cajerosConIncidencias })
  }

  handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') return
    this.setState({ mostrarAlerta: false })
  }

  filtrarPorBusqueda(lista) {
    const q = (this.state.filtroBusqueda || '').trim().toLowerCase()
    if (!q) return lista
    return lista.filter((c) =>
      (c.alias || '').toLowerCase().includes(q) ||
      (c.codigo || '').toString().toLowerCase().includes(q) ||
      (c.serial || '').toLowerCase().includes(q)
    )
  }

  render() {
    const incidenciaIds = new Set(this.state.cajerosConIncidencia.map((c) => c.id))
    const cajerosOperativos = this.state.cajeros.filter((c) => !incidenciaIds.has(c.id))

    const incidenciasFiltradas = this.filtrarPorBusqueda(this.state.cajerosConIncidencia)
    const operativosFiltrados = this.filtrarPorBusqueda(cajerosOperativos)

    const horaActualizacion = this.state.ultimaActualizacion
      ? this.state.ultimaActualizacion.toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit', second: '2-digit' })
      : '—'

    return (
      <Box>
        {/* Encabezado */}
        <Box sx={{ mb: 2 }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1}>
            <Box>
              <Typography variant="h5" sx={{ fontWeight: 800, color: '#222' }}>
                Estados de cajeros
              </Typography>
              <Stack direction="row" alignItems="center" gap={0.75} sx={{ mt: 0.5, color: '#666' }}>
                <AutorenewRoundedIcon sx={{ fontSize: 16 }} />
                <Typography variant="caption">
                  Auto-actualización cada {INTERVALO_UPDATE_MS / 1000}s · Última: {horaActualizacion}
                </Typography>
              </Stack>
            </Box>

            <Tooltip title="Actualizar ahora">
              <span>
                <IconButton
                  onClick={this.btnFiltrarCajeros}
                  disabled={this.state.cargando}
                  sx={{
                    backgroundColor: '#6A9E2C',
                    color: '#fff',
                    borderRadius: '12px',
                    '&:hover': { backgroundColor: '#5a8624' },
                    '&.Mui-disabled': { backgroundColor: '#a8c97e', color: '#fff' },
                  }}
                >
                  <RefreshIcon className={this.state.cargando ? 'spin-icon' : ''} />
                </IconButton>
              </span>
            </Tooltip>
          </Stack>
        </Box>

        {/* Filtros */}
        <Paper
          elevation={0}
          sx={{
            p: 2,
            mb: 2,
            borderRadius: '14px',
            border: '1px solid rgba(0,0,0,0.06)',
            backgroundColor: '#fff',
          }}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={5}>
              <FormControl fullWidth size="small">
                <InputLabel>Grupo</InputLabel>
                <Select
                  label="Grupo"
                  value={this.state.filtroGrupo}
                  onChange={this.handleGrupoChange}
                >
                  <MenuItem value={0}>-- Todos los cajeros / grupos --</MenuItem>
                  {this.state.grupos.map((grupo) => (
                    <MenuItem key={grupo.id} value={grupo.id}>
                      {grupo.nombre}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={7}>
              <TextField
                fullWidth
                size="small"
                placeholder="Buscar por alias, código o serial…"
                value={this.state.filtroBusqueda}
                onChange={this.handleBusquedaChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: '#888' }} />
                    </InputAdornment>
                  ),
                  endAdornment: this.state.filtroBusqueda && (
                    <InputAdornment position="end">
                      <IconButton size="small" onClick={() => this.setState({ filtroBusqueda: '' })}>
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </Paper>

        {/* Resumen */}
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12} sm={4}>
            <StatCard
              icon={<PointOfSaleRoundedIcon />}
              label="Cajeros totales"
              value={this.state.cajeros.length}
              color="#2E7DD7"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <StatCard
              icon={<WarningAmberRoundedIcon />}
              label="Con incidencias"
              value={this.state.cajerosConIncidencia.length}
              color="#D32F2F"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <StatCard
              icon={<CheckCircleOutlineRoundedIcon />}
              label="Operativos"
              value={cajerosOperativos.length}
              color="#2E7D32"
            />
          </Grid>
        </Grid>

        {/* Incidencias */}
        {this.state.cajerosConIncidencia.length > 0 && (
          <Box sx={{ mb: 3 }}>
            <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 1.5 }}>
              <WarningAmberRoundedIcon sx={{ color: '#D32F2F' }} />
              <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#222' }}>
                Cajeros con incidencias
              </Typography>
              <Chip
                label={incidenciasFiltradas.length}
                size="small"
                sx={{ backgroundColor: '#FDECEA', color: '#D32F2F', fontWeight: 700 }}
              />
            </Stack>

            {incidenciasFiltradas.length === 0 ? (
              <Paper elevation={0} sx={{ p: 2, borderRadius: '12px', border: '1px dashed rgba(0,0,0,0.08)', color: '#666' }}>
                Sin resultados para el filtro actual.
              </Paper>
            ) : (
              <Grid container spacing={2}>
                {incidenciasFiltradas.map((cajero) => (
                  <ItemCajeroIncidencia
                    key={cajero.id}
                    cajero={cajero}
                    categoriasEstados={this.state.categoriasEstados}
                  />
                ))}
              </Grid>
            )}
          </Box>
        )}

        {/* Operativos */}
        <Box>
          <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 1.5 }}>
            <CheckCircleOutlineRoundedIcon sx={{ color: '#2E7D32' }} />
            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#222' }}>
              Cajeros operativos
            </Typography>
            <Chip
              label={operativosFiltrados.length}
              size="small"
              sx={{ backgroundColor: '#E8F5E9', color: '#2E7D32', fontWeight: 700 }}
            />
          </Stack>

          {operativosFiltrados.length === 0 ? (
            <Paper elevation={0} sx={{ p: 2, borderRadius: '12px', border: '1px dashed rgba(0,0,0,0.08)', color: '#666' }}>
              {this.state.cajeros.length === 0
                ? 'No se encontraron cajeros para el grupo seleccionado.'
                : 'Sin resultados para el filtro actual.'}
            </Paper>
          ) : (
            <Grid container spacing={2}>
              {operativosFiltrados.map((cajero) => (
                <ItemCajero
                  key={cajero.id}
                  cajero={cajero}
                  categoriasEstados={this.state.categoriasEstados}
                />
              ))}
            </Grid>
          )}
        </Box>

        <Snackbar
          open={this.state.mostrarAlerta}
          onClose={this.handleCloseAlert}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Collapse in={this.state.mostrarAlerta}>
            <Alert
              severity={this.state.severidadAlerta}
              onClose={this.handleCloseAlert}
              variant="filled"
              sx={{ marginTop: 4, width: '100%', borderRadius: '12px' }}
            >
              <AlertTitle>{this.state.severidadAlerta.toUpperCase()}</AlertTitle>
              {this.state.mensajeAlerta}
            </Alert>
          </Collapse>
        </Snackbar>

        <style>{`
          @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
          .spin-icon { animation: spin 1s linear infinite; }
        `}</style>
      </Box>
    )
  }
}

export default CajeroEstadosPage
